import { JSError } from './JSError';
import type { TJSErrorParams } from './const';

type TObjectErrorExtras = {
  global?: string[];
  fields?: Record<string, string[]>;
};

export class ObjectError extends JSError<TObjectErrorExtras> {
  constructor(params: Omit<TJSErrorParams<TObjectErrorExtras>, 'name'>) {
    super({
      ...params,
      name: 'ObjectError',
    });
  }
}
